import React, {useState, useEffect} from 'react'
import { useForm } from 'react-hook-form'
import axios from 'axios'
import { yupResolver } from '@hookform/resolvers/yup'
import * as yup from 'yup'
import { Form, Button } from 'react-bootstrap'
/*Images-Icons*/
import '../styles/Contacto/ContactUs.css'
import Contact from '../assets/imagenes/contact_us.png'
import axiosPublic from '../api/Axios'

import { useTranslation } from 'react-i18next'
import { useLocation } from 'react-router-dom';

const schema = yup.object().shape({
  name: yup.string().required('Este campo es obligatorio'),
  email: yup.string().email('Correo electrónico no válido').required('Este campo es obligatorio'),
  phone: yup.string().required('Este campo es obligatorio').matches(/^\+?\d+$/, 'Telefono no es válido'),
  subject: yup.string().required('Este campo es obligatorio'),
  message: yup.string().required('Este campo es obligatorio')
})

function ContactUs() {
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);

  const location = useLocation();
  const prefillMessage = location.state && location.state.prefillMessage ? location.state.prefillMessage : '';
  const prefillSubject = location.state && location.state.prefillSubject ? location.state.prefillSubject : '';
  const { register, handleSubmit, reset, setValue, watch, formState: { errors } } = useForm({
    resolver: yupResolver(schema)
  })
    // Prefill message if coming from Cotizar
    useEffect(() => {
      if (prefillMessage) {
        setValue('message', prefillMessage);
      }
      if (prefillSubject) {
        setValue('subject', prefillSubject);
      }
    }, [prefillMessage, prefillSubject, setValue]);
  
  const onSubmit = async(data) => {
    setLoading(true)
    try{
      const response = await axiosPublic.post('api/user/contact', data)
        setSuccess(true)
        reset()
    } catch(error){
      console.log("el correo no pudo ser enviado")
      setSuccess(false)
    } finally {
      setLoading(false)
    } 
  }

  const allFields = watch();
  const isFormFilled = allFields.name && allFields.email && allFields.message && allFields.phone && allFields.subject;
  
  const {t} = useTranslation();

  return (
    <section className='contact-us'>
        <div className="title-container">
            <div className='txt-title'>
                <h2 style={{padding: '50px'}}>{t("contact")}</h2>
            </div>
        </div>

        <section className='contact-row'>
          <div className='contact-image'>
            <img src={Contact} alt='contacto' className='contacto' style={{ borderRadius: '18px' }}/>
          </div>

        <div className='form-container' style={{display: 'flex', flexDirection: 'column'}}>
          <Form onSubmit={handleSubmit(onSubmit)}>
            <Form.Group controlId='name'>
              <Form.Control 
                type='text' 
                placeholder={t("contact_name")} 
                {...register('name')}
              />
              </Form.Group>
              <Form.Group controlId='email'>
              <Form.Control 
                type='email' 
                placeholder='Email' 
                {...register('email')}
              />
              <p>{errors.email?.message}</p>
              </Form.Group>

              <Form.Group controlId='phone'>
              <Form.Control 
                type='text' 
                placeholder={t("contact_phone")} 
                {...register('phone')}
              />
              <p>{errors.phone?.message}</p>
              </Form.Group>

              <Form.Group controlId='subject'>
              <Form.Control 
                type='text' 
                placeholder={t("contact_subject")} 
                {...register('subject')}
              />
              </Form.Group>

              <Form.Group controlId='message'>
              <Form.Control 
                as="textarea" 
                rows={6} 
                placeholder={t("contact_message")}
                {...register('message')}
              />
              </Form.Group>

              <Button 
                type='submit' 
                disabled={!isFormFilled || loading}
                style={{backgroundColor: '#025C5A', border: 'none', padding: '10px', width: '100%'}}
              >
                {loading ? t("contact_loading") : t("contact_send")}
              </Button>
          </Form>

          {success && 
          <div style={{border: '1px solid green', padding: '10px', margin: '10px 0', width: '75%'}}>
            <p className="success" style={{margin: '0', color: 'green'}}>{t("contact_success")}</p>
          </div>}
        </div>
        </section>
    </section>
  )
}

export default ContactUs